import { useCheckBloomlifeIdMutation } from "@/data/queries"
import { Duration } from "@js-joda/core"
import { debounce as _debounce } from "lodash"
import { useMemo, useState } from "react"

type CheckBloomlifeIdProps = {
  debounce: Duration
}

type CheckBloomlifeIdResponse = {
  isInUse: boolean
}

const useCheckBloomlifeId = ({ debounce }: CheckBloomlifeIdProps) => {
  const {
    mutateAsync: checkBloomlifeId,
    isPending: isCheckingBloomlifeId,
    isError: isErrorCheckBloomlifeId,
  } = useCheckBloomlifeIdMutation()
  const [isBloomlifeIdInUse, setIsBloomlifeIdInUse] = useState<
    boolean | undefined
  >(false)
  const duration = debounce.toMillis()

  const debouncedCheckBloomlifeId = useMemo(
    () =>
      _debounce(async (value: string) => {
        try {
          const result = (await checkBloomlifeId(
            value
          )) as CheckBloomlifeIdResponse
          setIsBloomlifeIdInUse(result.isInUse)
        } catch (error) {
          console.error("Error checking Bloomlife ID:", error)
        }
      }, duration),
    [checkBloomlifeId, duration]
  )

  return {
    debouncedCheckBloomlifeId,
    isBloomlifeIdInUse,
    isCheckingBloomlifeId,
    isErrorCheckBloomlifeId,
    setIsBloomlifeIdInUse,
  }
}

export default useCheckBloomlifeId
